package ai.jessie.web.pages.registration

import ai.jessie.web.theme.ButtonVariant
import ai.jessie.web.theme.entryFrame
import ai.jessie.web.theme.linkButton
import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Page
@Composable
fun unavailablePage(ctx: PageContext) {
    // This marker selects copy only; it is not authentication or tenant authority.
    val membershipUnavailable = ctx.route.params["registration_outcome"] == "membership_unavailable"
    if (membershipUnavailable) {
        entryFrame("Organisationszugriff nicht verfügbar", authenticationRequired = true) {
            P {
                Text(
                    "Deine Identität wurde bestätigt. " +
                        "Der Zugriff auf deine Organisation konnte jedoch nicht geklärt werden."
                )
            }
            P { linkButton("Zur Startseite", "/") }
        }
    } else {
        entryFrame("Registrierung vorübergehend nicht verfügbar", authenticationRequired = true) {
            P {
                Text(
                    "Die Registrierung oder E-Mail-Bestätigung kann momentan nicht abgeschlossen " +
                        "werden. Versuche es später erneut."
                )
            }
            P {
                linkButton("Erneut versuchen", "/api/v1/registration/start", ButtonVariant.PRIMARY)
            }
        }
    }
}
